import { render, staticRenderFns } from "./WhyChooseSCAD.vue?vue&type=template&id=daad8b52&scoped=true&"
import script from "./WhyChooseSCAD.vue?vue&type=script&lang=js&"
export * from "./WhyChooseSCAD.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseSCAD.vue?vue&type=style&index=0&id=daad8b52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daad8b52",
  null
  
)

export default component.exports